/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Badge_No_CredentialInputs */



/**
* | output |
* | --- |
* | "No credential" |
*
* @param {Integrations_Apis_Badge_No_CredentialInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_badge_no_credential = /** @type {((inputs?: Integrations_Apis_Badge_No_CredentialInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Badge_No_CredentialInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Zugangsdaten")
	return /** @type {LocalizedString} */ ("No credential")
});